import axios from 'axios';
import Cookies from 'js-cookie';

var http = null;


class ApiProvider {

  typeFilters = [];
  advanced = [];

  constructor(config) {
    this.config = config;
    console.log('CONFIG:', config);
    var api_url = (this.config['mode'] === 'DEV')?this.config.api_url:window.location.origin+'/';
    http = axios.create({
      baseURL: api_url,
      headers: { 'Content-Type': 'application/json' }
    });
    http.defaults.xsrfHeaderName = "X-CSRFToken";
    http.defaults.xsrfCookieName = "csrftoken";
    if(this.config['mode']==='DEV') {
      this.token = "fgtQABEFEgtQY8Rr3ALY47hmYJ3EJ1";
      console.log(this.token);
      this.login(this.token);
    }
  }

  auth() {
    http.post(this.config['api_auth_url'], this.config.auth).then((response) => {
      this.token = response.data['access_token'];
      this.login(this.token);
    })
  }

  login(token) {
    console.log(token);
    http.defaults.headers.common.Authorization = `Bearer ${token}`;
    /* http.defaults.withCredentials = true; */
    this.getRecentEditsLogs().then((res) => {
        console.log(res);
        http.defaults.headers.common['X-CSRFToken'] = Cookies.get('csrftoken');
        Cookies.set('csrftoken', Cookies.get('csrftoken'));
    })
  }

  logout() {
    http.defaults.headers.common.Authorization = ''
  }

  resetAdvanced() {
    this.advanced = [];
  }

  resetTypeFilters() {
    this.typeFilters = [];
  }

  // REST Methods
  findArheoHeritageResource(area_id = "", sector_id = "", sector_ids = [], text_filter = "", page=1) {
    let sector_area_to_search = [];
    if (area_id === "") {
      sector_area_to_search.push("");
    } else if (sector_id !== "") {
      sector_area_to_search.push(sector_id);
    } else if (sector_id === "") {
      sector_area_to_search.push(...sector_ids);
      sector_area_to_search.push(area_id);
    }
    this.resetAdvanced();
    this.resetTypeFilters();
    this.addTypeFilterParam(this.config.archaeological_heritage_graph_id, this.config.archaeological_heritage_name);
    var advanced_group_general_data = {};
    this.addAdvancedOperand(advanced_group_general_data);

    var self = this;
    sector_area_to_search.forEach((elem_id) => {
      var advanced_group_area_ = {};
      self.addAdvancedOperand(advanced_group_area_, 'or');
      self.addAdvancedParam(advanced_group_area_, this.config.archaeological_heritage_area_tile_id, elem_id, "");
      self.advanced.push(advanced_group_area_);
    });
    this.addAdvancedParam(advanced_group_general_data, this.config.archaeological_general_data_tile_id, text_filter, "~");

    this.advanced.push(advanced_group_general_data);
    return http.get(`/${this.config.search_resources_path}`, { params: { 'format':'json','precision':'6','total':'7', 'resource-type-filter': JSON.stringify(this.typeFilters), 'advanced-search': JSON.stringify(this.advanced), 'no_filters': false, 'paging-filter': page } });
  }

  findHops3DRelated(heritage_id) {
    // return http.get(`/${this.config.search_related_resources_path}/${heritage_id}`);
    let advanced = [{'op':'and',[this.config.hop3d_heritage_tile_id]:{'op':'','val':heritage_id}}];
    let res_type_filter = [{'graphid': this.config.hop3d_graph_id,"name":"Nuvola di punti","inverted":false}];
    return http.get(`/${this.config.search_resources_path}`, 
      { params: { 'paging-filter':'1','format':'json','precision':'6','total':'7', 
                  'resource-type-filter': JSON.stringify(res_type_filter), 
                  'advanced-search': JSON.stringify(advanced), 
                  'no_filters': false, 'page': 1 } }).then((res) => {
                    let promises = [];
                    let data_list = res.data['results']['hits']['hits'];
                    for (let resource of data_list) {
                      promises.push(this.getResourceTilesByInstanceId(resource['_source']['resourceinstanceid']));
                    }
                    return axios.all(promises);
                  });
  }

  findReports() {
    return http.get(`/${this.config.search_reports_path}?paging-filter=1&format=json&precision=6&total=0&resource-type-filter=[{"graphid": "${this.config.report_graph_id}", "name": "Segnalazione", "inverted": false}]&provisional-filter=[{"provisionaltype":"Provisional","inverted":false}]`).then((res) => {
      
      let data = res.data['results']['hits']['hits'];

      let promises = [];
      for (let resource of data) {
        promises.push(this.getResourceTilesByInstanceId(resource['_source']['resourceinstanceid']));
      }
      return axios.all(promises);
    });
  }


  findCards(graph_id="", text_filter="", page_number="") {


    let type_filter = `resource-type-filter=[{"graphid": "${graph_id}", "name": "", "inverted": false}]`;
    let terms_filter = `term-filter=[{"inverted":false,"type":"string","context":"","context_label":"","id":"${text_filter}","text":"${text_filter}","value":"${text_filter}"}]`;
    
    let url = `${this.config.search_reports_path}?`;
    if(graph_id && graph_id!==null) url += type_filter;
    if(text_filter && text_filter!==null) url+= `&${terms_filter}`;
    return http.get(`/${url}&no_filters=false&paging-filter=${page_number}`);
  }


  findHeritages() {
    return http.get(`/${this.config.search_reports_path}?paging-filter=1&format=json&precision=6&total=8&resource-type-filter=[{"graphid": "${this.config.archaeological_heritage_graph_id}", "name": "Bene Archeologico", "inverted": false}]`).then((res) => {
      let data = res.data['results']['hits']['hits'];

      let promises = [];
      for (let resource of data) {
        promises.push(this.getResourceTilesByInstanceId(resource['_source']['resourceinstanceid']));
      }
      return axios.all(promises);
    });
  }

  getResourceTilesByInstanceId(resource_id) {
    return http.get(`/resource/${resource_id}/tiles`);
  }

  findGraphByName(name) {
    return http.get(`/${this.config.search_graph_path}?action=api&name=${name}`);
  }

  findGraphByID(graphid) {
    return http.get(`/graph/${graphid}/export`);
  }

  getRecentEditsLogs() {
    return http.get(`/dashboard/recent_edits`);
  }

  findDropdownHeritageArea() {
    return http.get(`/concepts/dropdown?conceptid=${this.config.area_concept_id}`);
/*     return this.findGraphByName(this.config.heritage_graph_name).then((response) => {
      let data = response.data;
      let graphid = data['0']['graphid'];
      console.log('GRAPH BY NAME:', data);
      return this.findGraphByID(graphid).then((res) => {
        let data = res.data;
        console.log('DATA FROM GRAPH:',data);
        let nodes = data['graph'][0]['nodes'].filter((elem) => { return elem['name'].includes(this.config.heritage_area_concept_name); });
        let concept_rdm_id = nodes[0]['config']['rdmCollection'];
        return http.get(`/concepts/dropdown?conceptid=${concept_rdm_id}`);
      });

    }); */
  }

  addTypeFilterParam(graphid, name) {
    this.typeFilters.push({
      "graphid": graphid,
      "name": name,
      "inverted": false
    });
  }

  addAdvancedParam(advance_group, tileid, value, op = "") {
    advance_group[tileid] = {
      "op": op,
      "val": value
    };
  }

  addAdvancedOperand(advance_group, operand = 'and') {
    advance_group['op'] = operand;
  }

  getAdvancedQueryParams() {

  }

  getTypeFilterQueryParams() {

  }

  getConceptsQueryParams(filter) {
    return {
      q: filter
    }
  }

  get({ resource, id, query }) {
    return http.get(`${resource}/${id}`, {
      params: query
    })
  }

  create({ resource, data, query }) {
    return http.post(resource, data, {
      params: query
    })
  }

  update({ resource, id, data, query }) {
    return http.patch(`${resource}/${id}`, data, {
      params: query
    })
  }

  destroy({ resource, id }) {
    return http.delete(`${resource}/${id}`)
  }
}

export default ApiProvider;